import React from "react";
import Loader from "@frameworks/shared-library/components/Loader";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesClientReports/ReportingClientSearchResult.scss";
var ReportingClientSearchResult = function (props) {
    var generateAccessDeniedMessage = function (htmlString) {
        var _a, _b, _c, _d;
        var errorMessage = (React.createElement("span", null,
            React.createElement("span", { className: "DMSanN_14_400" }, (_b = (_a = htmlString === null || htmlString === void 0 ? void 0 : htmlString.split(" ")) === null || _a === void 0 ? void 0 : _a.splice(0, 4)) === null || _b === void 0 ? void 0 : _b.join(" ")),
            "\u00A0",
            React.createElement("span", { className: "DMSanM_14_500" }, (_d = (_c = htmlString === null || htmlString === void 0 ? void 0 : htmlString.split(" ")) === null || _c === void 0 ? void 0 : _c.splice(4)) === null || _d === void 0 ? void 0 : _d.join(" "))));
        var message = (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "edel-icon-access-denied" },
                React.createElement("span", { className: "path1" }),
                React.createElement("span", { className: "path2" })),
            React.createElement("div", { className: "DMSanM_14_500 txt-midnight-blue" }, "Access Denied"),
            React.createElement("div", { className: "txt-midnight-blue" }, errorMessage !== null && errorMessage !== void 0 ? errorMessage : " ")));
        return message;
    };
    var generateComponent = function () {
        if (!!props.clientData && props.clientData.length) {
            return props.clientData.map(function (client) {
                if (!!client.accessMsg) {
                    return (React.createElement("div", { className: "access-denied-message-error d-flex align-items-center justify-content-center flex-column" }, generateAccessDeniedMessage(client.accessMsg)));
                }
                else {
                    return (React.createElement("div", { className: "p-3 d-flex flex-column gap-3 hand_cursor primary-search-result-container", onClick: function () { return props.handleSelectClient(client); } },
                        React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue" }, client.clientName),
                        React.createElement("div", { className: "d-flex align-items-center gap-1 DMSanM_14_500 txt_primaryGrey" },
                            React.createElement("span", null, "Account Code:"),
                            React.createElement("span", null, client.accountCode))));
                }
            });
        }
        else {
            if (props.searchLoader) {
                return React.createElement(Loader, null);
            }
            else {
                return React.createElement(Errormsg, { msg: "No Data Found" });
            }
        }
    };
    return React.createElement(React.Fragment, null, generateComponent());
};
export default ReportingClientSearchResult;
